import { LayoutModule } from '@angular/cdk/layout';
import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { MissingTranslationHandler, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';

import { CarrouselModule } from '@ecm/carrousel';
import { EcmConsumerModule, ErrorHandlerService } from '@ecm/consumer';
import { EcmDashboardModule } from '@ecm/dashboard';
import { EnvUtils } from '@ecm/dispatcher';
import { LayoutContainerComponent } from '@ecm/ecm/lib/components/layout-container.component';
import { ecmEnTranslation } from '@ecm/ecm/lib/i18n/en';
import { ecmFrTranslation } from '@ecm/ecm/lib/i18n/fr';
import { EcmMissingTranslationHandler } from '@ecm/ecm/lib/i18n/missing-translation';
import { DefaultRoutingModule } from '@ecm/ecm/lib/routing/default-routing.module';
import { EcmMaterialModule } from '@ecm/material';
import { EcmPortfolioModule } from '@ecm/portfolio';
import { EcmRouterModule, RouterReuseStrategy } from '@ecm/router';
import { ServiceHeaderModule } from '@ecm/service-header';
import { SmartbannerModule } from '@ecm/smartbanner';
import { EcmTrackerModule } from '@ecm/tracker';

import { AppComponent } from './app.component';

@NgModule({
    declarations: [AppComponent, LayoutContainerComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        TranslateModule.forRoot({
            missingTranslationHandler: { provide: MissingTranslationHandler, useClass: EcmMissingTranslationHandler },
            defaultLanguage: 'fr',
        }),
        DefaultRoutingModule,
        EcmConsumerModule,
        EcmDashboardModule,
        EcmMaterialModule,
        EcmPortfolioModule,
        EcmRouterModule,
        EcmTrackerModule,
        LayoutModule,
        ServiceHeaderModule,
        SmartbannerModule,
        CarrouselModule,
        NgxsModule.forRoot([]),
        NgxsReduxDevtoolsPluginModule.forRoot({ disabled: EnvUtils.production }),
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'fr' },
        DatePipe,
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        { provide: RouteReuseStrategy, useClass: RouterReuseStrategy },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {
    public constructor(translate: TranslateService) {
        translate.setTranslation('en', ecmEnTranslation, true);
        translate.setTranslation('fr', ecmFrTranslation, true);
    }
}
